import { render, staticRenderFns } from "./PasswordProfile.vue?vue&type=template&id=23568e0f&"
import script from "./PasswordProfile.vue?vue&type=script&lang=js&"
export * from "./PasswordProfile.vue?vue&type=script&lang=js&"
import style0 from "./PasswordProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports